import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-4" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "form-control"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2" }, null, -1)
const _hoisted_7 = { class: "col-sm-4" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "form-control"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-6 mb-3" }
const _hoisted_15 = { class: "box mb-3" }
const _hoisted_16 = { class: "boxTitle" }
const _hoisted_17 = { class: "box" }
const _hoisted_18 = { class: "boxTitle" }
const _hoisted_19 = { class: "col-sm-6 mb-3" }
const _hoisted_20 = { class: "box" }
const _hoisted_21 = { class: "boxTitle" }
const _hoisted_22 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_23 = { class: "col-sm-12 col-md-6" }
const _hoisted_24 = { class: "box" }
const _hoisted_25 = { class: "boxTitle" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = {
  key: 0,
  class: "form-control"
}
const _hoisted_28 = {
  key: 0,
  class: "row"
}
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_personal_data = _resolveComponent("personal-data")!
  const _component_accordion = _resolveComponent("accordion")!
  const _component_fiscal_data = _resolveComponent("fiscal-data")!
  const _component_contact_data = _resolveComponent("contact-data")!
  const _component_network_user_selector = _resolveComponent("network-user-selector")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Ruolo",
              text: "Ruolo"
            })
          ]),
          (_ctx.readonly)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.user.role), 1))
            : _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 1,
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.role) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rolesList, (item, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: item
                  }, _toDisplayString(item), 9, _hoisted_5))
                }), 128))
              ], 512)), [
                [_vModelSelect, _ctx.user.role]
              ])
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Stato commerciale",
              text: "Stato commerciale"
            })
          ]),
          (_ctx.canEditStatoCommerciale)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.statoCommerciale) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadStatoCommercialeList, (item, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: item
                    }, _toDisplayString(item), 9, _hoisted_10))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.user.statoCommerciale]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary ml-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveStatoCommerciale && _ctx.saveStatoCommerciale(...args)))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Salva",
                    text: "Salva"
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.readonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.user.statoCommerciale), 1))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.statoCommerciale) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadStatoCommercialeList, (item, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: item
                    }, _toDisplayString(item), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.user.statoCommerciale]
                ])
              ], 64))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_accordion, null, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dati personali",
                  text: "Dati personali"
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_personal_data, {
                value: _ctx.user.personalData,
                readonly: _ctx.readonly
              }, null, 8, ["value", "readonly"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_accordion, null, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dati fiscali",
                  text: "Dati fiscali"
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_fiscal_data, {
                value: _ctx.user.fiscalData,
                readonly: _ctx.readonly
              }, null, 8, ["value", "readonly"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_accordion, null, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dati di contatto",
                  text: "Dati di contatto"
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_contact_data, {
                value: _ctx.user.contactData,
                readonly: _ctx.readonly
              }, null, 8, ["value", "readonly"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.$store.state.isAdmin())
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_accordion, null, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Rete",
                      text: "Rete"
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Referral code",
                        text: "Referral code"
                      })
                    ]),
                    (_ctx.readonly)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.user.referralCode), 1))
                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.referralCode) = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.user.referralCode]
                        ])
                  ]),
                  (!_ctx.readonly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_network_user_selector, {
                            label: "Upliner gestione",
                            modelValue: _ctx.user.reteGestioneParent,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.reteGestioneParent) = $event)),
                            userIdentifier: _ctx.user.identifier
                          }, null, 8, ["modelValue", "userIdentifier"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_network_user_selector, {
                            label: "Upliner commerciale",
                            modelValue: _ctx.user.reteCommercialeParent,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.reteCommercialeParent) = $event)),
                            userIdentifier: _ctx.user.identifier
                          }, null, 8, ["modelValue", "userIdentifier"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}